import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { catchError, finalize, map, Observable, throwError } from 'rxjs';
import { LessonPage } from '../../data/models/LessonPage';
import { API } from '../../data/api';
import { SharedDataService } from '../../helper/services/shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class LessonPageService {

  constructor(private networkingService: NetworkingService, private sharedDataService: SharedDataService) { }

  getLessonPageList(id: string): Observable<LessonPage[]> {
    return this.networkingService.getRequest(API.lessonPageList(id))
      .pipe(
        map(response => response as LessonPage[])
      );
  }

  getLessonPageDetails(id: string): Observable<LessonPage> {
    const endpoint = API.lessonPageDetails(id);
    return this.networkingService.getRequest(endpoint)
      .pipe(
        map(response => response as LessonPage)
      );
  }

  createLessonPage(lessonPageData: {
    title: string;
    lessonId: string;
  }): Observable<LessonPage> {

    const payload: any = {
      title: lessonPageData.title,
      lesson_id: lessonPageData.lessonId,
    };

    return this.networkingService.postRequest(API.lessonPageCreate, payload).pipe(
      map((response) => response as LessonPage),
      catchError((error) => {
        console.error('Failed to create lesson page:', error);
        return throwError(() => new Error('Failed to create lesson page'));
      }),
      finalize(() => {
        this.sharedDataService.toggleProgressBarOff();
      })
    );
  }
}
 